import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, IconButton, Menu, MenuItem } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SecurityCheck from "../../SecurityCheck/SecurityCheck";
import { SecurityService } from "../../../services/SecurityService";
import { AlertContext } from "../../Dashboard/Dashboard";

export default function RegionsPeople({
  results,
  handleRegionUser
}) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [role, setRole] = useState({});
  const [userId, setUserId] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  let navigate = useNavigate();

  const handleMenu = (event, id) => {
    setUserId(id);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const onClickRecentActivity = () => {
    navigate(`/dashboard/admin/user-management/user-profile?user-id=${userId}`);
    handleClose();
  };

  const onClickChangeRegion = () => {
    handleRegionUser(userId);
    handleClose();
  };

  const onClickAssignManager = () => {
    navigate("user-management");
    handleClose();
  };

  useEffect(() => {
    setTimeout(() => {
      SecurityService.GetUserRoles(instance).then(res => {
        const role = res.find(({ roleName }) => roleName.trim() === "Carrier Rep Manager");
        setRole(role);
      }).catch(error => {
        console.error(error);
        warning(error);
      });
    }, 1);
  }, []);

  return (
    <Box>
      {results.map((r, i) => (
        <Box key={i} style={{ margin: "0 0 2px 20px", display: "flex", justifyContent: "space-between" }}>
          <span style={{ display: "flex", alignItems: "center" }}>
            <AccountCircleIcon sx={{ fontSize: "22px", color: "black_solid.80", marginRight: "5px" }} />
            <Typography sx={{
              margin: "10px 0",
              ...(r.isActive ? { color: "black_opacity.100" } : { color: "black_solid.60" })
            }}>
              {r.userName}
            </Typography>
            <Typography sx={{
              margin: "10px 10px",
              ...(r.isActive ? { color: "primary.60" } : { color: "primary.40" })
            }}>
              {role && r.roleId == role.roleId ? "Regional Manager" : ""}
            </Typography>
          </span>
          {r.isActive &&
            <span>
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                sx={{ color: "black_solid.80", "&:hover": { backgroundColor: "transparent" } }}
                onClick={(ev) => handleMenu(ev, r.userId)}
              >
                <KeyboardArrowDownIcon sx={{ color: "black_solid.60", paddingLeft: "5px" }} />
              </IconButton>
            </span>
          }
        </Box>
      ))
      }
      <Menu
        id="region-people-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "region-people-button",
        }}
        slotProps={{
          paper: {
            sx: { boxShadow: "elevation3" },
          }
        }}
      >
        <SecurityCheck
          componentName="Admin"
          action="Read"
        >
          <MenuItem onClick={onClickRecentActivity}>
            <Typography variant="h4" color="black_solid.80" >
              Recent Activity
            </Typography>
          </MenuItem>
        </SecurityCheck>
        <SecurityCheck
          componentName="Admin"
          action="Read"
        >
          <MenuItem onClick={onClickChangeRegion}>
            <Typography variant="h4" color="black_solid.80">
              Change Region
            </Typography>
          </MenuItem>
        </SecurityCheck>
        <SecurityCheck
          componentName="Admin"
          action="Read"
        >
          <MenuItem onClick={onClickAssignManager}>
            <Typography variant="h4" color="black_solid.80">
              Assign as Regional Manager
            </Typography>
          </MenuItem>
        </SecurityCheck>
      </Menu>
    </Box>
  );
}

RegionsPeople.propTypes = {
  results: PropTypes.array.isRequired,
  handleRegionUser: PropTypes.func.isRequired
};